import {useEffect, useState} from "react";

/** The current time, refreshed every `intervalMs`, so stale positions fade without waiting for the next poll. */
export const useLiveMapNow = (intervalMs = 60_000) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);
  return now;
};
